import { useAppoloStore } from "@/settings/zustand"
import { Icon, Intent } from "@blueprintjs/core"
import { ID } from "@libs/interfaces/layouts"
import { Loading, showToast } from "@libs/useful"
import { __ } from "@libs/utilities"
import gql from "graphql-tag"
import { default as UUID } from "node-uuid"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { IFestival, IFormField } from "../../data/interfaces"
import { IFestDataStor, useFestDataStore } from "../../data/store"
import { useFestival } from "../../hooks/festival"
import FormFields from "./FormFields"

interface IProps {

}
const ExternalProjectFieldsForm = (props:IProps) :JSX.Element => {
    const params = useParams() 
    const festId: ID = params.landId || "" ; //useMainStore((state: IState) => state.landId)
    const isLoading = useFestival(true, festId) 
    const festival: IFestival = useFestDataStore((state:IFestDataStor) => state.festival)
    const[ extendedFields, setFormFields ] = useState( festival.extendedFields || [] )
    const[ def, setDef ] = useState( JSON.stringify( festival.extendedFields || []) )
    const[isUpdate, setIsUpdate] = useState<boolean>(false)

    useEffect( () => useFestDataStore.subscribe(
        (state:IFestDataStor) => {
            setFormFields( state.festival.extendedFields || [] )
            setDef( JSON.stringify( state.festival.extendedFields || []) )
        }
    ), [] )

    const updateFestival = () => {
        const mutation: string =  `
            mutation changeFestival {
                changePEFestival (
                    input: {
                        extendedFields: ${
                            getExtendedsString( extendedFields )
                        }
                    }
                    ${festId ? `land_id: "${festId}"` : ""}
                ) {
                    extendedFields {
                        id
                        type
                        name
                        count
                        hide_in_page
                        hide_in_card
                        hide_in_projects
                        hide_for_alien
                        highlighted
                        description
                        values
                        require
                    }
                }
            }`
        // console.log( mutation )
        const apolloClient: any = useAppoloStore.getState().client
        setIsUpdate(true)
        apolloClient.mutate({  mutation : gql`${mutation}` })
            .then(( response: any ) => {
                // console.log( { ...festival, ...response.data.changePEFestival } )
                const _festival:IFestival = { ...festival, ...response.data.changePEFestival }
                useFestDataStore.getState().setFestival( _festival )
                setDef( JSON.stringify( _festival ) )
                setIsUpdate(false)
                localStorage.removeItem( "pe-fest-data-storage" )
                showToast({
                    message: __("Successful update"),
                    intent: Intent.SUCCESS
                })
            })
    }

    if( isLoading ) return <Loading />
    
    const onFormFieldChange = (form_fields: IFormField[] ) =>
	{
        // console.log( form_fields )
		onUpdate("form_fields", form_fields);
		setFormFields( form_fields )
	}
    const onUpdate = ( param: string, value: IFormField[] ) =>
    { 

    } 
    return <div className="position-relative mb-5">

        <div 
            className={ ` position-sticky mr-2 mt-2 top` }
            style={{ zIndex: 100 }}
        >
            <div 
                className={` mt-2 position-absolute right btn btn-sm btn-${( JSON.stringify(extendedFields) !== def) ? 'danger' : 'secondary opacity_5 untouchble'}`}
                onClick={updateFestival} 
            >
                <Icon 
                    icon={ isUpdate ? "repeat" : "tick" }
                    className={ isUpdate ? "mr-2 fa fa-spin" : "mr-2" }
                /> 
                {__("Update Extended Fields data")}
            </div>
        </div>

        <div className="lead mb-1">{__("Every Member's fields")}</div>
        <div className="small my-2">
            {__("These fields will be displayed in each Project's account with their own values. These values can be edited by Project owners")}
        </div>
        <FormFields
            data={ extendedFields }
            onChange={ onFormFieldChange } 
        />
    </div>
} 

export default ExternalProjectFieldsForm


const getExtendedsString = ( extendeds: IFormField[]) => {  
    const str :string[] =  extendeds.map((e:IFormField) => {
        return `
                            {
                                id : "${ e.id || UUID.v4() }",
                                name: "${e.name || ""}",
                                type: "${e.type || "string"}",
                                count: ${e.count || 0},
                                hide_in_page: ${e.hide_in_page || false},
                                hide_in_card: ${e.hide_in_card || false},
                                hide_in_projects: ${e.hide_in_projects || false}, 
                                hide_for_alien: ${e.hide_for_alien || false}, 
                                highlighted: ${e.highlighted || false}, 
                                description: "${e.description || ""}",
                                values: "${e.values || ""}",
                                require: ${e.require || false}
                            }`
    }) 
    return `[${ str.join(`,`) }]`
}